(() => {
  const init = () => {
    const page = document.querySelector('[data-ts-legal-page]');
    const body = page && page.querySelector('.shopify-policy__body');
    if (!body || page.dataset.legalReady === 'true') return;
    if (page.dataset.legalStatic === 'true') {
      const source = body.querySelector('.rte > div:not(#itkanzlei_txt_copyright)');
      const firstLine = source && source.firstChild;
      if (!body.querySelector('h2') && firstLine && firstLine.nodeType === 3 && firstLine.textContent.trim()) {
        const heading = document.createElement('h2');
        source.insertBefore(heading, firstLine);
        heading.appendChild(firstLine);
        if (heading.nextSibling && heading.nextSibling.nodeName === 'BR') heading.nextSibling.remove();
      }
      page.dataset.legalReady = 'true';
      return;
    }
    const headings = Array.from(body.querySelectorAll('h2')).filter(heading => !heading.closest('details'));
    if (!headings.length) return;
    const panels = [];
    headings.forEach((heading, index) => {
      const parent = heading.parentNode;
      const nodes = [];
      let next = heading.nextSibling;
      while (next && !(next.nodeType === 1 && (next.tagName === 'H2' || next.id === 'itkanzlei_txt_copyright'))) {
        nodes.push(next);
        next = next.nextSibling;
      }
      const details = document.createElement('details');
      details.className = 'ts-legal-section';
      details.id = `ts-legal-section-${index + 1}`;
      const summary = document.createElement('summary');
      const content = document.createElement('div');
      content.className = 'ts-legal-section-content';
      parent.insertBefore(details, heading);
      summary.appendChild(heading);
      nodes.forEach(node => content.appendChild(node));
      details.append(summary, content);
      details.open = false;
      if (!/^\d+[).\s]/.test(heading.textContent.trim()) && content.querySelector('ol')) details.classList.add('ts-legal-toc');
      panels.push(details);
    });
    const sections = panels.filter(panel => !panel.classList.contains('ts-legal-toc'));
    panels.filter(panel => panel.classList.contains('ts-legal-toc')).forEach(toc => {
      const items = Array.from(toc.querySelectorAll('.ts-legal-section-content > ol > li'));
      items.forEach((item, index) => {
        const target = sections[index];
        if (!target) return;
        const original = item.textContent.replace(/\s+/g, ' ').trim();
        const label = target.querySelector('h2').textContent.replace(/^\d+[).]\s*/, '').replace(/\s+/g, ' ').trim();
        if (original !== label) return;
        let link = item.querySelector('a');
        if (!link) {
          link = document.createElement('a');
          while (item.firstChild) link.appendChild(item.firstChild);
          item.appendChild(link);
        }
        link.href = `#${target.id}`;
        link.addEventListener('click', event => {
          event.preventDefault();
          target.open = true;
          const summary = target.querySelector('summary');
          summary.focus({ preventScroll: true });
          target.scrollIntoView({ block: 'start', behavior: 'auto' });
        });
      });
    });
    page.dataset.legalReady = 'true';
    window.addEventListener('pageshow', event => {
      if (event.persisted) panels.forEach(panel => { panel.open = false; });
    });
    let printState = null;
    window.addEventListener('beforeprint', () => {
      printState = panels.map(panel => panel.open);
      panels.forEach(panel => { panel.open = true; });
    });
    window.addEventListener('afterprint', () => {
      if (printState) panels.forEach((panel, index) => { panel.open = printState[index]; });
      printState = null;
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
